// src/components/ProfileUpdatePage/Tabs/AboutLabTab.jsx
import React, { useState, useEffect } from 'react';
import * as api from '../layouts/DummyApi'; // Adjust path

const AboutLabTab = ({ aboutLab, setAboutLab, onSave }) => {
  const [formData, setFormData] = useState(aboutLab);
  const [allPaymentOptions, setAllPaymentOptions] = useState([]);
  const [isLoadingPaymentOptions, setIsLoadingPaymentOptions] = useState(false);

  useEffect(() => {
    setFormData(aboutLab); // Update form data if parent's aboutLab changes
  }, [aboutLab]);

  useEffect(() => {
    const loadPaymentOptions = async () => {
      setIsLoadingPaymentOptions(true);
      try {
        const response = await api.fetchPaymentOptions();
        setAllPaymentOptions(response.data);
      } catch (error) {
        console.error("Failed to fetch payment options:", error);
      } finally {
        setIsLoadingPaymentOptions(false);
      }
    };
    loadPaymentOptions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePaymentOptionChange = (e) => {
    const { value, checked } = e.target;
    const optionId = parseInt(value);
    const optionName = allPaymentOptions.find(opt => opt.id === optionId)?.name;

    let updatedPaymentOptions;
    if (checked) {
      updatedPaymentOptions = [
        ...formData.healthCareProviderPaymentOptions,
        { id: 0, healthCareProviderId: formData.healthCareProviderId, paymentOptionsId: optionId, paymentOptionName: optionName }
        // Note: 'id' and 'healthCareProviderId' are dummy here, backend usually assigns
      ];
    } else {
      updatedPaymentOptions = formData.healthCareProviderPaymentOptions.filter(
        (option) => option.paymentOptionsId !== optionId
      );
    }
    setFormData(prev => ({ ...prev, healthCareProviderPaymentOptions: updatedPaymentOptions }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAboutLab(formData); // Update parent state
    onSave(formData); // Pass data to parent to initiate API call
  };

  return (
    <form onSubmit={handleSubmit} className="profile-form">
      {/* healthCareProviderId is typically not editable */}
      <div className="form-group">
        <label htmlFor="labDetails">About the Lab</label>
        <textarea id="labDetails" name="labDetails" value={formData.labDetails || ''} onChange={handleChange} rows="5"></textarea>
      </div>
      <div className="form-group">
        <label htmlFor="workDays">Work Days</label>
        <input type="text" id="workDays" name="workDays" value={formData.workDays || ''} onChange={handleChange} placeholder="e.g., Mon-Fri, Sat" />
      </div>
      <div className="form-group">
        <label htmlFor="workHours">Work Hours</label>
        <input type="text" id="workHours" name="workHours" value={formData.workHours || ''} onChange={handleChange} placeholder="e.g., 8:00 AM - 5:00 PM" />
      </div>
      <div className="form-group">
        <label htmlFor="thingToKnow">Things to Know</label>
        <textarea id="thingToKnow" name="thingToKnow" value={formData.thingToKnow || ''} onChange={handleChange} rows="3"></textarea>
      </div>

      <div className="form-group">
        <label>Payment Options</label>
        {isLoadingPaymentOptions ? (
          <p className="loading-message">Loading payment options...</p>
        ) : (
          <div className="checkbox-group">
            {allPaymentOptions.map((option) => (
              <label key={option.id} className="checkbox-label">
                <input
                  type="checkbox"
                  value={option.id}
                  checked={formData.healthCareProviderPaymentOptions.some(
                    (selected) => selected.paymentOptionsId === option.id
                  )}
                  onChange={handlePaymentOptionChange}
                />
                {option.name}
              </label>
            ))}
          </div>
        )}
      </div>
      <button type="submit">Save About Lab Details</button>
    </form>
  );
};

export default AboutLabTab;